export default __webpack_public_path__ + "static/media/Artist10.d761bb52.svg";